var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Trans, Typography } from '@lucidlink/uicore';
export const GlobalDefaultsHeader = () => {
    return (_jsxs(Box, { gap: "s", orientation: "vertical", children: [_jsx(Typography, { as: "h3", color: "accent", kind: "h5", children: _jsx(Trans, { children: "Global defaults" }) }), _jsx(Typography, { kind: "p-small", children: _jsx(Trans, { children: "The settings in this section apply to all devices connecting to this filespace. Some changes may require users to reconnect for updates to take effect. Users can still adjust settings locally." }) })] }));
};
_react_refresh_temp_1 = GlobalDefaultsHeader;
$RefreshReg$(_react_refresh_temp_1, "GlobalDefaultsHeader");
